import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VendorModalService {

  private selectedVendorSubject = new BehaviorSubject<any>(null);
  public selectedVendor$ = this.selectedVendorSubject.asObservable();

  constructor() { }

  setSelectedVendor(vendor: any): void {
    this.selectedVendorSubject.next(vendor);
  }

  getSelectedVendor(): any | null {
    return this.selectedVendorSubject.value;
  }

  clearSelectedVendor(): void {
    this.selectedVendorSubject.next(null);
  }
}
